export const CUSTOM_USER_GROUPS = {
    HAS_ANY_PATIENT: 'HAS_ANY_PATIENT',
};
